'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractErrorMessages = exports.generalActionTypes = exports.actionCreator = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _lodash = require('lodash');
var actionCreator = exports.actionCreator = function actionCreator(type, payload) {
  if (payload === undefined) {
    return {
      type: type
    };
  }
  return {
    type: type,
    payload: payload
  };
};
var generalActionTypes = exports.generalActionTypes = {
  NON_HANDLED_ERROR: 'general/NON_HANDLED_ERROR'
};
var extractErrorMessages = exports.extractErrorMessages = function extractErrorMessages(objError) {
  if (typeof objError === "string") {
    return objError;
  } else if ((typeof objError === 'undefined' ? 'undefined' : _typeof(objError)) === "object") {
    if (Object.keys(objError).length > 0) {
      var messages = [];
      Object.keys(objError).map(function (keyMessages) {
        objError[keyMessages].map(function (message) {
          var fieldReference = keyMessages.split('.');
          var splitedMessage = message.split(' ');
          var newMessage = (0, _lodash.pull)(splitedMessage, keyMessages).join(' ');
          if (fieldReference.length > 1) {
            messages.push('Em ' + fieldReference[0].toUpperCase() + ' o campo ' + fieldReference[1].toUpperCase() + ' ' + newMessage);
          } else {
            messages.push(message);
          }
        });
      });
      return messages.join('\n');
    }
  }
  return "Não foi possível realizar esta operação no momento.";
};